import React from 'react'

const PageLoading = () => {
    return <div className="py-5 text-center"><i style={{ fontSize: '2rem' }} className=" my-5 py-5 fas fa-sync-alt fa-spin" /></div>
}

export default PageLoading
